import { Component, Input, OnInit } from '@angular/core';
import { faComment, faStar, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { MysupportEvaluationService } from './service/mysupport-evaluation.service';
import { EvaluationMspInterface } from 'src/app/util/interfaces/evaluationMsp';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';

@Component({
	standalone: true,
	imports: [CommonModule, FontAwesomeModule, SvgGearsModule],
	selector: 'app-mysupport-evaluation',
	templateUrl: './mysupport-evaluation.component.html',
	styleUrl: './mysupport-evaluation.component.scss',
})
export class MysupportEvaluationComponent implements OnInit {
	icons = {
		faThumbsUp: faThumbsUp,
		faThumbsDown: faThumbsDown,
		faStar: faStar,
		faComment: faComment,
	};

	labels: LabelsInterface = {
		lbl_geral_selecione: 'SELECT',
		lbl_cmdb: 'CMDB',
		lbl_chamado: 'Request',
		lbl_geral_relatorio: 'Report',
		lbl_geral_registrar: 'Register',
		lbl_status_estoque: 'Stock',
		lbl_geral_salvar: 'Save',
		lbl_geral_pesquisa_satisfacao: 'Satisfaction Survey',
		lbl_asset_category: 'Category',
		lbl_geral_comentarios: 'Comments',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_obrigatorio_selecionar_opcao_gostar_nao_gostar: "It is mandatory to select an option of 'like' or 'dislike'",
		lbl_asset_other: 'Other',
		lbl_geral_cancelar: 'Cancel',
		lbl_edocs_carregando: 'Loading',
		lbl_comentario_opcional: 'Comment (Optional)',
		lbl_deixar_comentario: 'Leave a comment',
		lbl_esta_gostando_do_MySupport: 'Are you enjoying MySupport?',
	};

	isLoadingLabels = true;
	isLoadingEvaluation = false;
	likeSelected = false;
	dislikeSelected = false;

	accessCmdb = false;
	accessCockpit = false;
	accessKb = false;
	accessRegister = false;
	accessReports = false;
	accessRequest = false;
	accessStock = false;

	valueDescription = '';
	valueEvaluation = '';
	valueCmdb = 0;
	valueCockpit = 0;
	valueRegister = 0;
	valueKnowledge = 0;
	valueReport = 0;
	valueStock = 0;
	valueRequest = 0;

	constructor(
		private LabelsService: LabelsService,
		private mysupportEvaluationService: MysupportEvaluationService,
		private notification: NotificationService,
		private ProfileService: ProfileService
	) {}

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.viewCategoriesCustomer();
	}

	toggleLike(evaluationType: string): void {
		if (evaluationType === 'like') {
			this.likeSelected = !this.likeSelected;
			this.dislikeSelected = false;
		} else if (evaluationType === 'dislike') {
			this.dislikeSelected = !this.dislikeSelected;
			this.likeSelected = false;
		}

		this.valueEvaluation = evaluationType;
	}

	saveContent(): void {
		this.isLoadingEvaluation = true;

		if (!this.valueEvaluation || this.valueEvaluation === '' || this.valueEvaluation === null) {
			this.notification.setNotificationMessage(this.labels.lbl_obrigatorio_selecionar_opcao_gostar_nao_gostar);
			this.isLoadingEvaluation = false;
			return;
		}

		const evaluationMsp: EvaluationMspInterface = {
			evaluation: this.valueEvaluation,
			description: this.valueDescription,
			cmdb: this.valueCmdb,
			cockpit: this.valueCockpit,
			register: this.valueRegister,
			knowledge: this.valueKnowledge,
			report: this.valueReport,
			stock: this.valueStock,
			request: this.valueRequest,
		};

		this.mysupportEvaluationService
			.postMysupportEvaluation(evaluationMsp)
			.subscribe(() => {
				this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.valueDescription = '';
				this.valueEvaluation = '';
				this.likeSelected = false;
				this.dislikeSelected = false;
			})
			.add(() => {
				setTimeout(() => {
					this.isLoadingEvaluation = false;
				}, 100);
			});
	}

	updateCharCount(event: any): void {
		const maxLength = 512;
		const currentLength = event.target.value.length;
		const counter = document.querySelector('.char-counter');
		counter.textContent = `${currentLength}/${maxLength}`;
	}

	viewCategoriesCustomer(): void {
		this.accessCmdb = this.ProfileService.userData().permission.includes('access_cmdb');
		this.accessCockpit = this.ProfileService.userData().permission.includes('access_cockpit');
		this.accessKb = this.ProfileService.userData().permission.includes('access_kb');
		this.accessRegister = this.ProfileService.userData().permission.includes('access_register');
		this.accessReports = this.ProfileService.userData().permission.includes('access_reports');
		this.accessRequest = this.ProfileService.userData().permission.includes('access_request');
		this.accessStock = this.ProfileService.userData().permission.includes('access_stock');
	}
}
